import { configureStore } from "@reduxjs/toolkit";

import authReducer from "./slices/authSlice";
import agentReducer from "./slices/agentSlice";
import dashboardReducer from "./slices/dashboardSlice";
import appointmentReducer from "./slices/appointmentSlice";
import invoiceReducer from "./slices/invoiceSlice";
import serviceReducer from "./slices/serviceSlice";
import faqReducer from "./slices/faqSlice";
import shopReducer from "./slices/shopSlice";
import loaderReducer from "./slices/loaderSlice";
import notificationReducer from "./slices/notificationSlice";
import userReducer from "../Data/features/userSlice";
import sessionMiddleware from "../Data/middleware/sessionMiddleware";
import { userApi } from "../Data/services/userApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    agent: agentReducer,
    dashboard: dashboardReducer,
    appointment: appointmentReducer,
    invoice: invoiceReducer,
    service: serviceReducer,
    faq: faqReducer,
    shop: shopReducer,
    loader: loaderReducer,
    notification: notificationReducer,
    user: userReducer,
    [userApi.reducerPath]: userApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([userApi.middleware, sessionMiddleware]),
});
